// extracted by mini-css-extract-plugin
module.exports = {"screen":"NotFound_screen__1ybGd","errorMsg":"NotFound_errorMsg__39smI"};